'use strict';

export namespace UrlQuery {
  export function getParam(variable: string, defaultValue: string = ''): string {
    const query = window.location.search.substring(1);

    for (const pair of query.split('&')) {
      const [key, value] = pair.split('=');

      if (key === variable) {
        return decodeURIComponent(value) || defaultValue;
      }
    }

    return defaultValue;
  }
}



// WEBPACK FOOTER //
// ./src/typescripts/client/utils/urlQuery.ts